/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CashbackOfferAdminDto } from '../models/CashbackOfferAdminDto';
import type { CashbackOfferBranchListType } from '../models/CashbackOfferBranchListType';
import type { GetCashbackOfferBranchRatiosAdminResponse } from '../models/GetCashbackOfferBranchRatiosAdminResponse';
import type { GetCashbackOfferChannelsAdminResponse } from '../models/GetCashbackOfferChannelsAdminResponse';
import type { GetCashbackOfferExcludeBranchesAdminResponse } from '../models/GetCashbackOfferExcludeBranchesAdminResponse';
import type { GetCashbackOfferGroupsAdminResponse } from '../models/GetCashbackOfferGroupsAdminResponse';
import type { GetCashbackOfferIncludeBranchesAdminResponse } from '../models/GetCashbackOfferIncludeBranchesAdminResponse';
import type { GetCashbackOfferRegionsAdminResponse } from '../models/GetCashbackOfferRegionsAdminResponse';
import type { GetCashbackOfferServicesAdminResponse } from '../models/GetCashbackOfferServicesAdminResponse';
import type { GetCashbackOfferUsersAdminResponse } from '../models/GetCashbackOfferUsersAdminResponse';
import type { GetCashbackOfferVariationsAdminResponse } from '../models/GetCashbackOfferVariationsAdminResponse';
import type { ImportCashbackOfferBranchesAdminResponse } from '../models/ImportCashbackOfferBranchesAdminResponse';
import type { Pagination1OfCashbackOfferListedAdminDto } from '../models/Pagination1OfCashbackOfferListedAdminDto';
import type { PostCashbackOfferAdminRequest } from '../models/PostCashbackOfferAdminRequest';
import type { PutCashbackOfferAdminRequest } from '../models/PutCashbackOfferAdminRequest';
import type { PutCashbackOfferBranchRatiosRequestAdmin } from '../models/PutCashbackOfferBranchRatiosRequestAdmin';
import type { PutCashbackOfferChannelsRequestAdmin } from '../models/PutCashbackOfferChannelsRequestAdmin';
import type { PutCashbackOfferExcludeBranchesRequestAdmin } from '../models/PutCashbackOfferExcludeBranchesRequestAdmin';
import type { PutCashbackOfferGroupsRequestAdmin } from '../models/PutCashbackOfferGroupsRequestAdmin';
import type { PutCashbackOfferIncludeBranchesRequestAdmin } from '../models/PutCashbackOfferIncludeBranchesRequestAdmin';
import type { PutCashbackOfferRegionsRequestAdmin } from '../models/PutCashbackOfferRegionsRequestAdmin';
import type { PutCashbackOfferServicesRequestAdmin } from '../models/PutCashbackOfferServicesRequestAdmin';
import type { PutCashbackOfferUsersRequestAdmin } from '../models/PutCashbackOfferUsersRequestAdmin';
import type { PutCashbackOfferVariationsRequestAdmin } from '../models/PutCashbackOfferVariationsRequestAdmin';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CashbackOffersService {
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns CashbackOfferAdminDto Created
     * @throws ApiError
     */
    public static postCashbackOfferAdmin({
        requestBody,
    }: {
        requestBody?: PostCashbackOfferAdminRequest,
    }): CancelablePromise<CashbackOfferAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/cashback-offers',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCashbackOffers`
     * @returns Pagination1OfCashbackOfferListedAdminDto OK
     * @throws ApiError
     */
    public static getCashbackOffersAdmin({
        startDate,
        endDate,
        isActive,
        branchId,
        regionId,
        page,
        limit,
    }: {
        startDate?: string,
        endDate?: string,
        isActive?: boolean,
        branchId?: number,
        regionId?: number,
        page?: number,
        limit?: number,
    }): CancelablePromise<Pagination1OfCashbackOfferListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cashback-offers',
            query: {
                'startDate': startDate,
                'endDate': endDate,
                'isActive': isActive,
                'branchId': branchId,
                'regionId': regionId,
                'page': page,
                'limit': limit,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCashbackOfferDetails`
     * @returns CashbackOfferAdminDto OK
     * @throws ApiError
     */
    public static getCashbackOfferAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<CashbackOfferAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cashback-offers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns CashbackOfferAdminDto OK
     * @throws ApiError
     */
    public static putCashbackOfferAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCashbackOfferAdminRequest,
    }): CancelablePromise<CashbackOfferAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cashback-offers/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteCashbackOffers`
     * @returns any OK
     * @throws ApiError
     */
    public static deleteCashbackOfferAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/cashback-offers/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCashbackOffers`
     * @returns GetCashbackOfferUsersAdminResponse OK
     * @throws ApiError
     */
    public static getCashbackOfferUsersAdmin({
        id,
        userId,
    }: {
        id: number,
        userId?: string,
    }): CancelablePromise<GetCashbackOfferUsersAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cashback-offers/{id}/users',
            path: {
                'id': id,
            },
            query: {
                'userId': userId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns GetCashbackOfferUsersAdminResponse OK
     * @throws ApiError
     */
    public static updateCashbackOfferUsersAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCashbackOfferUsersRequestAdmin,
    }): CancelablePromise<GetCashbackOfferUsersAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cashback-offers/{id}/users',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCashbackOffers`
     * @returns GetCashbackOfferGroupsAdminResponse OK
     * @throws ApiError
     */
    public static getCashbackOfferGroupsAdmin({
        id,
        groupId,
    }: {
        id: number,
        groupId?: number,
    }): CancelablePromise<GetCashbackOfferGroupsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cashback-offers/{id}/groups',
            path: {
                'id': id,
            },
            query: {
                'groupId': groupId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns GetCashbackOfferGroupsAdminResponse OK
     * @throws ApiError
     */
    public static updateCashbackOfferGroupsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCashbackOfferGroupsRequestAdmin,
    }): CancelablePromise<GetCashbackOfferGroupsAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cashback-offers/{id}/groups',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCashbackOffers`
     * @returns GetCashbackOfferChannelsAdminResponse OK
     * @throws ApiError
     */
    public static getCashbackOfferChannelsAdmin({
        id,
        channelId,
    }: {
        id: number,
        channelId?: number,
    }): CancelablePromise<GetCashbackOfferChannelsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cashback-offers/{id}/channels',
            path: {
                'id': id,
            },
            query: {
                'channelId': channelId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns GetCashbackOfferChannelsAdminResponse OK
     * @throws ApiError
     */
    public static updateCashbackOfferChannelsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCashbackOfferChannelsRequestAdmin,
    }): CancelablePromise<GetCashbackOfferChannelsAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cashback-offers/{id}/channels',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCashbackOffers`
     * @returns GetCashbackOfferServicesAdminResponse OK
     * @throws ApiError
     */
    public static getCashbackOfferServicesAdmin({
        id,
        serviceId,
    }: {
        id: number,
        serviceId?: number,
    }): CancelablePromise<GetCashbackOfferServicesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cashback-offers/{id}/services',
            path: {
                'id': id,
            },
            query: {
                'serviceId': serviceId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns GetCashbackOfferServicesAdminResponse OK
     * @throws ApiError
     */
    public static updateCashbackOfferServicesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCashbackOfferServicesRequestAdmin,
    }): CancelablePromise<GetCashbackOfferServicesAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cashback-offers/{id}/services',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCashbackOffers`
     * @returns GetCashbackOfferIncludeBranchesAdminResponse OK
     * @throws ApiError
     */
    public static getCashbackOfferIncludeBranchesAdmin({
        id,
        branchId,
    }: {
        id: number,
        branchId?: number,
    }): CancelablePromise<GetCashbackOfferIncludeBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cashback-offers/{id}/include-branches',
            path: {
                'id': id,
            },
            query: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns GetCashbackOfferIncludeBranchesAdminResponse OK
     * @throws ApiError
     */
    public static updateCashbackOfferIncludeBranchesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCashbackOfferIncludeBranchesRequestAdmin,
    }): CancelablePromise<GetCashbackOfferIncludeBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cashback-offers/{id}/include-branches',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCashbackOffers`
     * @returns GetCashbackOfferExcludeBranchesAdminResponse OK
     * @throws ApiError
     */
    public static getCashbackOfferExcludedBranchesAdmin({
        id,
        branchId,
    }: {
        id: number,
        branchId?: number,
    }): CancelablePromise<GetCashbackOfferExcludeBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cashback-offers/{id}/excluded-branches',
            path: {
                'id': id,
            },
            query: {
                'branchId': branchId,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns GetCashbackOfferExcludeBranchesAdminResponse OK
     * @throws ApiError
     */
    public static updateCashbackOfferExcludedBranchesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCashbackOfferExcludeBranchesRequestAdmin,
    }): CancelablePromise<GetCashbackOfferExcludeBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cashback-offers/{id}/excluded-branches',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCashbackOffers`
     * @returns GetCashbackOfferRegionsAdminResponse OK
     * @throws ApiError
     */
    public static getCashbackOfferRegionsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCashbackOfferRegionsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cashback-offers/{id}/regions',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns GetCashbackOfferRegionsAdminResponse OK
     * @throws ApiError
     */
    public static updateCashbackOfferRegionsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCashbackOfferRegionsRequestAdmin,
    }): CancelablePromise<GetCashbackOfferRegionsAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cashback-offers/{id}/regions',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns ImportCashbackOfferBranchesAdminResponse OK
     * @throws ApiError
     */
    public static importCashbackOfferBranchesAdmin({
        id,
        formData,
    }: {
        id: number,
        formData?: {
            file?: Blob;
            list?: CashbackOfferBranchListType;
        },
    }): CancelablePromise<ImportCashbackOfferBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/cashback-offers/{id}/branches/import',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCashbackOffers`
     * @returns GetCashbackOfferVariationsAdminResponse OK
     * @throws ApiError
     */
    public static getCashbackOfferVariationsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCashbackOfferVariationsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cashback-offers/{id}/variations',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns GetCashbackOfferVariationsAdminResponse OK
     * @throws ApiError
     */
    public static updateCashbackOfferVariationsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCashbackOfferVariationsRequestAdmin,
    }): CancelablePromise<GetCashbackOfferVariationsAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cashback-offers/{id}/variations',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewCashbackOffers`
     * @returns GetCashbackOfferBranchRatiosAdminResponse OK
     * @throws ApiError
     */
    public static getCashbackOfferBranchRatiosAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetCashbackOfferBranchRatiosAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/cashback-offers/{id}/branch-ratios',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageCashbackOffers`
     * @returns GetCashbackOfferBranchRatiosAdminResponse OK
     * @throws ApiError
     */
    public static updateCashbackOfferBranchRatiosAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutCashbackOfferBranchRatiosRequestAdmin,
    }): CancelablePromise<GetCashbackOfferBranchRatiosAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/cashback-offers/{id}/branch-ratios',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
